/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { toNaiveISO } from '../../utils/date';
import { IPaginationPayload } from '../../interfaces/shared/IPaginationPayload';
import { tryToFetchReports } from '../../store/admin/reports/reportsSlice';
import Modal from '../../shared/modal';
import ReportsTable from './ReportsTable';
import SelectCheckbox from '../../shared/select-checkbox';
import { tryToFetchAllJourneys } from '../../store/admin/trips/adminTripsSlice';
import { tryToFetchAllTeamMembers } from '../../store/brokers/partners/teams/teamsSlice';
import DateRangePopover from '../../features/admin/homepage/components/DateRange';
import Input from '../../shared/input';
import { useTheme } from '../../utils/theme-context';
import Button from '../../shared/button';

const REPORT_TYPES = [
    { label: 'Train Manager Report', value: 'Train Manager Report' },
    { label: 'Quality Report', value: 'Quality Report' },
]

const ReportsModal = ({
    open,
    onClose,
}: {
    open: boolean;
    onClose: () => void;
}) => {
    const { theme } = useTheme();
    const dispatch = useAppDispatch();
    const [reports, setReports] = useState<any>();
    const [trips, setTrips] = useState<any>();
    const [trainManagers, setTrainManagers] = useState<any>();
    const [staff, setStaff] = useState<any>();
    const [selectedType, setSelectedType] = useState<any>();
    const [selectedTrip, setSelectedTrip] = useState<any>();
    const [selectedTrainManager, setSelectedTrainManager] = useState<any>();
    const [selectedStaff, setSelectedStaff] = useState<any>();
    const [search, setSearch] = useState<string>();
    const [startDateRange, setStartDateRange] = useState<[Date, Date] | null>(null);
    const [endDateRange, setEndDateRange] = useState<[Date, Date] | null>(null);
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const reportsData = useAppSelector(state => state?.reports?.data)
    const paginationData = useAppSelector((state) => state.reports?.reports?.data?.page);

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10,
        })
    }

    useEffect(() => {
        if (reportsData?.elements) {
            setReports(reportsData?.elements)
        }
    }, [reportsData])

    const onGettingDetails = async () => {
        try {
            const trainManagerRes = await dispatch(tryToFetchAllTeamMembers({ role: 'train_manager' })).unwrap();
            const formatTrainManagers = trainManagerRes && trainManagerRes?.length > 0 && trainManagerRes?.map((item: any) => {
                return {
                    ...item || {},
                    label: item?.name || item?.username,
                    value: item?._id,
                }
            })
            setTrainManagers(formatTrainManagers)
            const journeysRes = await dispatch(tryToFetchAllJourneys()).unwrap();
            const formatJourneys = journeysRes?.elements && journeysRes?.elements?.length > 0 && journeysRes?.elements?.map((item: any) => {
                return {
                    ...item || {},
                    label: item?.journeyTitle,
                    value: item?._id,
                }
            })
            setTrips(formatJourneys || undefined)
            const staffRes = await dispatch(tryToFetchAllTeamMembers({ type: 'staff' })).unwrap();
            const formatStaff = staffRes && staffRes?.length > 0 && staffRes?.map((item: any) => {
                return {
                    ...item || {},
                    label: item?.name || item?.username,
                    value: item?._id,
                }
            })
            setStaff(formatStaff)
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(()=>{
        onGettingDetails()
    },[])

    const onPrepareFilters = () => {
        let formatData: any
        if (search) {
            formatData = {
                ...formatData || {},
                filters: search
            }
        }
        if (selectedTrip && selectedTrip?.value !== 'all') {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    itineraryId: selectedTrip?.value
                }
            }
        }
        if (selectedTrainManager) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    trainManagerId: selectedTrainManager?.value
                }
            }
        }
        if (selectedStaff) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    crewMemberId: selectedStaff?.value
                }
            }
        }
        if (selectedType) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    reportType: selectedType?.value
                }
            }
        }
        if (startDateRange) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    startDateMin: toNaiveISO(startDateRange?.[0]),
                    startDateMax: toNaiveISO(startDateRange?.[1])
                }
            }
        }
        if (endDateRange) {
            formatData = {
                ...formatData || {},
                data: {
                    ...formatData?.data || {},
                    endDateMin: toNaiveISO(endDateRange?.[0]),
                    endDateMax: toNaiveISO(endDateRange?.[1])
                }
            }
        }
        return formatData
    }

    const onGettingData = async () => {
        try {
            const formatData: any = {
                ...paginationState || {},
                ...onPrepareFilters() || {}
            }
            await dispatch(tryToFetchReports(formatData)).unwrap();
        } catch (err) {
            setReports(undefined)
        }
    }

    useEffect(() => {
        onGettingData();
    }, [paginationState]);


    const onClickClearAll = () => {
        setStartDateRange(null)
        setEndDateRange(null)
        setSelectedStaff(undefined)
        setSelectedTrainManager(undefined)
        setSelectedTrip(undefined)
        setSelectedType(undefined)
        setSearch(undefined)
        onResetPaginationState()
    }

    const onChangeSearchValue = (e: any) => {
        setSearch(e)
        onResetPaginationState();
    }

    const onChangeEndTripsDate = (value: any) => {
        setEndDateRange(value)
        onResetPaginationState()
    }

    const onChangeStartTripsDate = (value: any) => {
        setStartDateRange(value)
        onResetPaginationState()
    }

    const onChangeSelectedFilter = (value: any, type?: string) => {
        if (type) {
            switch (type) {
                case 'type':
                    setSelectedType(value);
                    break;
                case 'trainManager':
                    setSelectedTrainManager(value)
                    break;
                case 'trip':
                    setSelectedTrip(value)
                    break;
                case 'staff':
                    setSelectedStaff(value)
                    break;
            }
            onResetPaginationState();
        }
    }

    return (
        <Modal
            open={open}
            title={'All Reports'}
            onClose={onClose}
            contentContainerStyle='!rounded-xl min-w-[95%] md:min-w-[90%] lg:min-w-[80%]'>
            <div className='p-2 max-w-[95vw] md:min-w-[70%] lg:min-w-[70%] min-h-[500px]'>
                <div className='bg-gray-100 dark:bg-gray-800 p-4 rounded-md shadow-md my-10'>
                    <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-4'>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Itinerary</label>
                            <SelectCheckbox
                                placeholder='All Itineraries'
                                options={trips}
                                selectedOption={selectedTrip}
                                uniqueName='trip'
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Report Type</label>
                            <SelectCheckbox
                                placeholder='All Reports'
                                options={REPORT_TYPES}
                                selectedOption={selectedType}
                                uniqueName='type'
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Train Manager</label>
                            <SelectCheckbox
                                placeholder='All Train Managers'
                                options={trainManagers}
                                selectedOption={selectedTrainManager}
                                uniqueName='trainManager'
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                        <div>
                            <label className='block mb-1 font-medium dark:text-white'>Crew Member</label>
                            <SelectCheckbox
                                placeholder='All Crew Members'
                                options={staff}
                                selectedOption={selectedStaff}
                                uniqueName='staff'
                                onChangeSelectedOption={onChangeSelectedFilter}
                            />
                        </div>
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-6 gap-4'>
                        <div className='lg:col-span-2'>
                            <DateRangePopover
                                label='Start Date Range'
                                value={startDateRange}
                                showTime={true}
                                onChange={onChangeStartTripsDate}
                            />
                        </div>
                        <div className='lg:col-span-2'>
                            <DateRangePopover
                                label='End Date Range'
                                value={endDateRange}
                                showTime={true}
                                onChange={onChangeEndTripsDate}
                            />
                        </div>
                        <div className='pt-2'>
                            <Input
                                placeholder={'Search'}
                                containerStyle='mb-0 md:mt-5 relative dark:bg-bgColor-darkMode'
                                inputStyle={`mb-0 border-0 focus:outline-none dark:bg-black dark:text-primary-darkMode`}
                                icon={theme === 'dark' ? '/assets/navigation-icons/sidebar/search-icon-white.svg' : '/assets/shared/search.svg'}
                                showValue={true}
                                inputValue={search}
                                inputUniqueName={'search'}
                                onChangeInput={onChangeSearchValue}
                                hideInputSpace={true}
                            />
                        </div>
                        <div className='flex flex-row justify-center items-center'>
                            <Button
                                label={'Reset'}
                                icon={<img src={theme === 'dark' ? '/assets/insights-tab/reset-white.svg' : '/assets/insights-tab/reset.svg'} className='object-contain w-[24px] mr-2' />}
                                className='btn-primary-rounded !rounded-full !bg-white dark:!bg-black !text-[#1E4380] dark:!text-white !px-4 flex flex-row items-center justify-center mt-4'
                                onClickButton={onClickClearAll}
                            />
                        </div>
                    </div>
                </div>
                <ReportsTable
                    rows={reports}
                    paginationData={paginationData}
                    paginationState={paginationState}
                    setPaginationState={setPaginationState}
                />
            </div>
        </Modal>
    );
};

export default ReportsModal;
